// extracted by mini-css-extract-plugin
export default {"tooltip__expression-line":"ElementTooltipExpression_tooltip__expression-line__XX645"};